export default "__VITE_ASSET__CXrHDp5H__"